import {ReactElement,} from 'react';

import {Stack,} from '@mantine/core';

import {useApplicationProducts} from '../hooks/useApplicationProducts.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';


import {useApplicationProductsSelection} from '../hooks/useApplicationProductsSelection.ts';
import {
    ApplicationProduct,
    ApplicationProductStatus,
} from '../types';
import {useParams} from "react-router-dom";
import {useApplicationProductsPaging} from '../hooks/useApplicationProductsPaging.ts';
import {useApplicationProductsSearch} from '../hooks/useApplicationProductsSearch.ts';
import {DataTableColumn} from 'mantine-datatable';
import {useApplicationProductsTableColumns} from '../hooks/useApplicationProductsTableColumns.tsx';
import {rbacActions} from '../../../config/rbac/actions.ts';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import classes from './RecordsTable.module.css';


export const RecordsTable = (
    {
        records,
        extraTools,
        settings,
    }: {
        records: ApplicationProduct[],
        extraTools?: ReactElement[],
        settings?: { label: string, onClick: () => void }[]
    }
) => {


    const {id: applicationId} = useParams()
    if (!applicationId) {
        throw new Error('applicationId is required parameter')
    }


    const {allowedActions} = useVerifiedPermissions()

    const {
        loading,
        visibleCount,
    } = useApplicationProducts(applicationId);

    const {
        columns,
    } = useApplicationProductsTableColumns(applicationId);

    const {
        page,
        limit,
        handleItemsPerPageChange,
        handlePageChange,
    } = useApplicationProductsPaging();

    const {
        handleFilterByKeyword,
    } = useApplicationProductsSearch();

    const {
        selection,
        handleClearSelection,
        handleRowSelection,
    } = useApplicationProductsSelection();

    let selectedRecords = [] as ApplicationProduct[];
    if (allowedActions.includes(rbacActions.DeleteApplicationProduct)) {
        selectedRecords = Object.keys(selection)
                                .filter(id => selection[id] === true)
                                .map(id => records.find(r => r.id === id))
                                .filter(Boolean) as ApplicationProduct[];
    }

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />


            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                totalRecords={visibleCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        handleRowSelection((item as ApplicationProduct).id, true)
                    })
                }}
                rowClassName={(record) => {
                    if (record.applicationProductStatus === ApplicationProductStatus.ACTIVE) {
                        return classes.active;
                    } else if (record.applicationProductStatus === ApplicationProductStatus.INACTIVE) {
                        return classes.inactive;
                    }
                }}
                fetching={loading}
            />


        </Stack>
    );
};
